import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import { useReportOptions } from '../../hooks/useReportOptions.js';
import ColorPicker from '../../../common/ColorPicker/DashboardColorPicker.jsx';
import styles from '../base/CommonSettings.module.scss';
import Select, {oldArrToSelectFormatter} from '../../../common/Select.jsx';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import WidgetTitleSettings from '../../settings_sidebar/WidgetTitleSettings.jsx';

function ReportStatusWidgetSettings({ widgetId }) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const {data: reportOptions} = useReportOptions();
    const report_id = useSelector(state => state.dashboard.widgets[widgetId].settings?.report_id);
    const submit_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.submit_color);
    const draft_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.draft_color);
    const block_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.block_color);
    const reportOptionsSelect = useMemo(() => oldArrToSelectFormatter(reportOptions, 'id', 'name'), [reportOptions]);

    return (<>
        <hr />
        <CollapsibleSection title={I18n.t('content_settings')}>
            <div className={styles['settings-section']}>
                <WidgetTitleSettings widgetId={widgetId} />
                <div className={styles['settings-option']}>
                    <label>{I18n.t("report")}</label>
                    <Select
                        value={report_id}
                        options={reportOptionsSelect}
                        onChange={(value) => setAttribute("settings.report_id", value)}
                    />
                </div>
                <div className={styles['settings-option']}>
                    <label>{I18n.t("submitted_or_approved_color")}</label>
                    <ColorPicker value={submit_color} onChange={(value) => setAttribute('settings.submit_color', value)} />
                </div>
                <div className={styles['settings-option']}>
                    <label>{I18n.t("draft_or_assigned_color")}</label>
                    <ColorPicker value={draft_color} onChange={(value) => setAttribute('settings.draft_color', value)} />
                </div>
                <div className={styles['settings-option']}>
                    <label>{I18n.t("blocked_color")}</label>
                    <ColorPicker value={block_color} onChange={(value) => setAttribute('settings.block_color', value)} />
                </div>
            </div>
        </CollapsibleSection>
    </>)
}

export default ReportStatusWidgetSettings;
